import { GameHud } from '@/ui/hud/GameHud';

export function UiRoot() {
  return (
    <div className="pointer-events-none absolute inset-0 z-20 flex flex-col justify-between">
      <GameHud />
    </div>
  );
}
